import { isEqual } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getMethod } from "../../store/actions";
import TableSkeleton from "../Loader/TableSkeleton";

const SalesTable = ({ CollectionName }) => {
  const dispatch = useDispatch();
  const [listing, setlisting] = useState(null);
  useEffect(async () => {
    const res = await dispatch(
      getMethod(
        "salevolume",
        { contract_address: CollectionName },
        process.env.REACT_APP_REQUEST_URL
      )
    );
    if (res.isSuccess) {
      setlisting(res.data);
      console.log(res.data);
    }
  }, [CollectionName]);

  return (
    <div className="chart-box bg-white self-mt">
      <div className="site-table mobile-table">
        <table className="table darkhead">
          <thead>
            <tr>
              <th>Month</th>
              <th>Sale in dollars (ETH)</th>
              <th>Unique buyers</th>
              <th>Total Transactions</th>
              <th>Avg sale in dollars (ETH)</th>
            </tr>
          </thead>
          {!listing ? (
            <tbody>
              <TableSkeleton colSpan={5} rows={3} />
            </tbody>
          ) : (
            <tbody>
              {listing &&
                listing.map((res, index) => (
                  <tr key={index}>
                    <td date-title="Month" class="data-highlight">
                      {res.month_name}
                    </td>
                    <td data-title="Sale in dollars (ETH)">
                      {res.sale_in_dollars}
                    </td>
                    <td data-title="Unique buyers">{res.unique_buyers}</td>
                    <td data-title="Total Transactions">
                      {res.total_transactions}
                    </td>
                    <td data-title="Avg sale in dollars (ETH)">
                      {res.avg_sale_in_dollars_ETH}
                    </td>
                  </tr>
                ))}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default React.memo(SalesTable, isEqual);
